// extracted by mini-css-extract-plugin
module.exports = {"container":"PageTitle_container__1Wvga","center":"PageTitle_center__xvkpT"};